export default __webpack_public_path__ + "static/media/googlepay.e83086bd.png";